var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraGroupLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 6.5,
    width: 12,
    height: 12,
    rx: 2,
    stroke: "current",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 9.5L18.1056 7.94721C19.4354 7.28231 21 8.2493 21 9.73607V15.2639C21 16.7507 19.4354 17.7177 18.1056 17.0528L15 15.5V9.5Z",
    stroke: "current",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraGroupLogo);
export default __webpack_public_path__ + "static/media/camera_group_logo.0b3f9bbe9340ac2ef98e97b889a45f4e.svg";
export { ForwardRef as ReactComponent };